export default __webpack_public_path__ + "static/media/drawing-desk-5.55354f16.jpg";